import api from '@pray/shared/utils/api';

import type { WorkflowVersionResponse } from './data/response';
import type { CreateVersionRequest } from './data/types';

type CreateVersionProps = {
  artistId: string;
  workflowId: string;
  data: CreateVersionRequest;
};

export async function createVersion({
  artistId,
  workflowId,
  data,
}: CreateVersionProps): Promise<WorkflowVersionResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!workflowId) throw new Error('Workflow ID is required');
  if (!data.workflow_snapshot) throw new Error('Workflow snapshot is required');

  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}/versions`;

  const response = await api.executePostRequest<WorkflowVersionResponse>(url, data);

  return response.data;
}
